import { ImageBackground, StyleSheet, Text, View } from 'react-native';

import { MyTablesButtonBg, TournamentsButtonBg } from '../../../../assets';
import { testProps } from '../../../../config';
import { TouchableOpacity } from '../../common/Touchable';

type TournamentDesktopBarProps = {
	activeTablesLabel: string;
	onMyTablesPress: () => void;
	onTournamentStatsPress: () => void;
	scaleSize: (value: number) => number;
	tournamentFooterFontSize: number;
	tournamentFooterSpacer: number;
	tournamentsLabel: string;
	width: number;
};

const TournamentDesktopBar = ({
	activeTablesLabel,
	onMyTablesPress,
	onTournamentStatsPress,
	scaleSize,
	tournamentFooterFontSize,
	tournamentFooterSpacer,
	tournamentsLabel,
	width,
}: TournamentDesktopBarProps) => {
	const styles = createStyles(scaleSize, tournamentFooterFontSize, tournamentFooterSpacer);
	return (
		<View style={styles.tournamentDesktopBar}>
			<ImageBackground
				source={MyTablesButtonBg}
				style={styles.mainLobbyBtnDesktopBg}
				resizeMode='stretch'
			>
				<TouchableOpacity onPress={onMyTablesPress} {...testProps('cta-tournament-my-tables')}>
					<Text
						numberOfLines={1}
						adjustsFontSizeToFit
						minimumFontScale={0.75}
						style={styles.tournamentFooterTextDesktop}
					>
						{activeTablesLabel}
					</Text>
				</TouchableOpacity>
			</ImageBackground>

			<View style={styles.tournamentDesktopSpacer} />

			<ImageBackground
				source={TournamentsButtonBg}
				style={[styles.mainLobbyBtnActiveBg, width < 900 && styles.mainLobbyBtnActiveBgNarrow]}
				resizeMode='stretch'
			>
				<TouchableOpacity onPress={onTournamentStatsPress} {...testProps('cta-tournament-stats')}>
					<Text
						numberOfLines={1}
						adjustsFontSizeToFit
						minimumFontScale={0.75}
						style={[styles.tournamentFooterTextDesktop, styles.tournamentFooterTextGold]}
					>
						{tournamentsLabel}
					</Text>
				</TouchableOpacity>
			</ImageBackground>
		</View>
	);
};

const createStyles = (
	scaleSize: (value: number) => number,
	tournamentFooterFontSize: number,
	tournamentFooterSpacer: number,
) =>
	StyleSheet.create({
		tournamentDesktopBar: {
			flexDirection: 'row',
			justifyContent: 'space-between',
			width: '100%',
			paddingHorizontal: 0,
			maxHeight: scaleSize(40),
			position: 'absolute',
			bottom: 0,
			marginBottom: scaleSize(33),
			zIndex: 0,
			elevation: 0,
		},
		mainLobbyBtnDesktopBg: {
			flex: 1,
			aspectRatio: 3,
			marginRight: 0,
		},
		tournamentFooterTextDesktop: {
			color: 'white',
			fontWeight: 800,
			textTransform: 'uppercase',
			fontSize: tournamentFooterFontSize,
			marginTop: 6,
			textAlign: 'center',
			marginBottom: 3,
		},
		tournamentFooterTextGold: {
			color: '#423113',
		},
		tournamentDesktopSpacer: {
			width: tournamentFooterSpacer,
		},
		mainLobbyBtnActiveBg: {
			flex: 1,
			aspectRatio: 3,
			marginLeft: 0,
		},
		mainLobbyBtnActiveBgNarrow: {},
	});

export default TournamentDesktopBar;
